import { Link } from 'react-router-dom'

import { ROUTES } from '@/config/routes'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardTitle } from '@/components/ui/card'
import { PageLayout } from '@/layouts'

const registerOptions = [
  {
    title: 'Cadastrar CNPJ',

    description: 'Use esta opção para cadastrar um novo cliente ou vincular novas empresas a um proprietário já existente.',
    path: ROUTES.REGISTER_CLIENT_CNPJ.path
  }
  // ,
  // {
  //   title: 'Cadastrar Cliente PF',
  //   description: 'Informe o CPF e o endereço da pessoa física. Para cadastrar uma pessoa como cliente.',
  //   path: ROUTES.REGISTER_CLIENT_PF.path
  // },
] as const

export function CadastrarClientePage() {
  return (
    <PageLayout
      title="Cadastrar Cliente"
    >
      <div className="mx-auto flex w-full max-w-4xl flex-col gap-4">
        {registerOptions.map(option => (
          <Card key={option.path} className="border-border/60">
            <CardContent className="flex flex-col gap-4 p-4 md:flex-row md:items-center md:justify-between">
              <div className="space-y-1">
                <CardTitle className="text-base">{option.title}</CardTitle>
                <CardDescription className="text-sm">{option.description}</CardDescription>
              </div>
              <Button asChild className="w-full md:w-auto">
                <Link to={option.path}>Abrir</Link>
              </Button>
            </CardContent>
          </Card>
        ))}
      </div>
    </PageLayout>
  )
}
